import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './SearchFiltersModalV2.module.css';

export const ChevronIcon = props => {
  const { isOpen } = props;
  return (
    <span className={classNames(css.chevron, { [css.chevronOpen]: isOpen })} aria-hidden="true" />
  );
};

ChevronIcon.defaultProps = {
  isOpen: false,
};

ChevronIcon.propTypes = {
  isOpen: PropTypes.bool,
};

export const SlidersIcon = () => (
  <span className={css.slidersIcon} aria-hidden="true">
    <span />
    <span />
    <span />
  </span>
);

export const CloseIcon = () => (
  <span className={css.closeIcon} aria-hidden="true">
    <span />
    <span />
  </span>
);
